<template>
  <a-config-provider :locale="antdLocale">
    <router-view />
  </a-config-provider>
</template>

<script>
import axios from "axios"
import { useStore } from 'vuex'
import { message } from "ant-design-vue"
import { computed, ref, watch} from 'vue'
import { useI18n } from 'vue-i18n'
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');

export default {
  setup() {
    // useWindowWatcher();
    const store = useStore();
    const antdLocale = ref(zhCN);

    //* 监听系统locale变化并设置i18n
    const { locale } = useI18n();
    const sysLocale = computed(() => {return store.state.locale;})
    watch(() => sysLocale.value, (newVal) => {
      locale.value = newVal;
    });

    //* 获取api配置
    (async () => {
      const apiConfig = await axios
        .get("api.config.json")
        .catch(() => message.error("获取api配置失败，请检查配置文件"));
        store.commit("setApiConfig", apiConfig.data);
    })();
    // setApiConfig();

    //* 监听网络状态
    const networkState = computed(() => {return store.state.networkState;})
    watch(() => networkState, (newVal) => {
      if(!newVal.value){
        message.error("网络异常，请检查网络连接");
      }
    })

    //* 刷新操作保留用户的基本信息
    if(localStorage.getItem("gs-token")){
      store.commit("setToken", localStorage.getItem("gs-token"));
    }

    window.addEventListener("beforeunload",()=>{
      if(store.state.token){
        localStorage.setItem("gs-token", store.state.token);
      }
    })

    return { antdLocale };
  }
};
</script>

<style lang="less">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  overflow: hidden auto;
}

body {
  padding: 0;
  margin: 0;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
